import {
  getContextVariables,
  getCurrencySymbol,
  getDictionaryLabels,
  getPriceCurrencyOrder,
  isDealsPage,
  managePlurals,
  replacePlaceholders,
  searchService,
} from '@msc-b2c/shared-utils';

const searchParams: any = {
  distinct: 1,
  hitsPerPage: 8,
  pageFromRequest: 0,
  filters: '',
  context: '',
  clickAnalytics: true,
};

const updateNightsRibbon = (teaser: HTMLElement, firstHit: any): void => {
  const nightsRibbon = teaser.querySelector<HTMLElement>(
    '.cmp-teaser__ribbon__text--number-of-nights'
  );
  if (!nightsRibbon) {
    return;
  }

  const numberOfNights = firstHit?.numberOfNights;
  if (numberOfNights == null || Number.isNaN(Number(numberOfNights))) {
    nightsRibbon.classList.add('hide');
    return;
  }

  const dictionaryLabels = getDictionaryLabels();
  const nightsLabel = managePlurals(numberOfNights, dictionaryLabels['night']);
  nightsRibbon.innerHTML = replacePlaceholders(nightsRibbon.innerHTML, {
    numberOfNights: String(numberOfNights),
    night: nightsLabel,
  });
};

export const setupDealOfferTeaser = (dealsTeasers: HTMLElement[]): void => {
  dealsTeasers.forEach((dealsTeaser: HTMLElement) => {
    //The first child contains data properties for the dynamic search on Algolia
    const teaser: HTMLElement = dealsTeaser.firstElementChild as HTMLElement;
    // To get the price of the cruise, we need to know if it is a cabin or person search and the ID of the cruise or Itinerary code
    let filter = '';
    let price = '';
    if (teaser?.getAttribute('data-cabin-cruise-id')) {
      filter = `(cruiseID:${teaser.getAttribute('data-cabin-cruise-id')})`;
      price = 'cabinPrice';
    } else if (teaser?.getAttribute('data-person-cruise-id')) {
      filter = `(cruiseID:${teaser.getAttribute('data-person-cruise-id')})`;
      price = 'adultPrice';
    } else if (teaser?.getAttribute('data-person-itinerary-code')) {
      filter = `(itinCd:${teaser.getAttribute('data-person-itinerary-code')})`;
      price = 'adultPrice';
    } else if (teaser?.getAttribute('data-cabin-itinerary-code')) {
      filter = `(itinCd:${teaser.getAttribute('data-cabin-itinerary-code')})`;
      price = 'cabinPrice';
    } else {
      return;
    }

    searchParams.filters = filter ?? '';
    const teaserId = teaser.getAttribute('id');
    searchParams.context = getContextVariables(
      teaserId ? teaserId.replace('-', '_') : 'deals-teaser',
      isDealsPage()
    );

    searchService
      .performSearchCruises(searchParams)
      .then((response: any) => {
        if (response.hits.length >= 1) {
          let minPrice = response.hits[0].prices[price];
          response.hits.forEach((hit: any) => {
            if (hit.prices[price] < minPrice) {
              minPrice = hit.prices[price];
            }
          });
          const styleOptionDealsStyled = dealsTeaser.classList.contains(
            'cmp-teaser_teaserDeals-restyled'
          );
          const priceDiv = teaser.querySelector('.cmp-teaser__price__value');

          if (styleOptionDealsStyled && priceDiv) {
            const priceOrder = getPriceCurrencyOrder();
            const currencySymbol = getCurrencySymbol();
            const price = replacePlaceholders(priceOrder, {
              currency: currencySymbol,
              price: minPrice,
            });
            priceDiv.innerHTML = `<span class="cmp-teaser__price__value__text">${price}</span>`;
          }
          if (!styleOptionDealsStyled && priceDiv)
            priceDiv.innerHTML =
              `<span class="cmp-teaser__price__value__text">${minPrice}</span>` +
              '<span class="cmp-teaser__price__value__currency">' +
              getCurrencySymbol() +
              '</span>';
          updateNightsRibbon(teaser, response.hits[0]);
        } else {
          const ribbon = teaser.querySelector('.cmp-teaser__price');
          ribbon?.classList.add('hide');
          teaser
            .querySelector('.cmp-teaser__ribbon__text--number-of-nights')
            ?.classList.add('hide');
        }
      })
      .catch((error) => {
        console.error('Error occurred during cruises search:', error);
      });
  });
};
